/**
 * Created by razial on 04.03.2025.
 */

const UnitsLibraryHelper = {
    Switch: function (locationId) {
        cleverapps.unitsLibrary = this.GetInstance(locationId);
    },

    Reset: function () {
        cleverapps.unitsLibrary = undefined;
    },

    GetInstance: function (locationId) {
        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        return cleverapps.unitsLibrary && cleverapps.unitsLibrary.locationConfig === locationConfig
            ? cleverapps.unitsLibrary
            : new UnitsLibrary(locationConfig);
    },

    ResolveRewardUnits: function (reward) {
        return reward;
    }
};

SyncAdapters.unitsLibraryHelper = {
    beforeUpdate: () => {
        UnitsLibraryHelper.Reset();
    }
};

UniversalSlot.registerTable("unitslibrary", {
    getInfo: (slot) => slot.load("unitslibrary") || {},
    updateInfo: (slot, serverData) => slot.save("unitslibrary", serverData, true)
});
